<template>
  <div>
    <div class="box">
      <van-row class="info">
        <van-col span="12">
          <h1>
            分数: <span>{{ score }}</span>
          </h1>
          <h1>
            步数: <span>{{ steps }}</span>
          </h1>
        </van-col>
        <van-col span="12" class="text-right">
          <h1>
            时间: <span>{{ time }}</span>
          </h1>
        </van-col>
      </van-row>

      <div id="game7"></div>

      <div class="copy">copy @ 南山甄品</div>
    </div>

    <van-popup v-model="showStart" :style="{ height: '100%', width: '100%' }">
      <div class="panel">
        <h1 class="logo">弹球</h1>
        <br />
        <van-tag v-if="play_times_free>play_times_today" type="success" size="large">今日免费次数： {{play_times_today}} / {{play_times_free}}</van-tag>
        <br /><br />
        <ul>
          <li v-if="play_times_free<=play_times_today">{{ playScore }} 金豆游戏一次</li>
          <li>{{ playTime }} 秒游戏时间</li>

          <li>
            单次移动,累计消除宝石满 {{ clearConf.count2 }} 个,奖励时间
            {{ clearConf.addTime2 }} 秒
          </li>
          <li>
            单次移动,累计消除宝石满 {{ clearConf.count1 }} 个,奖励时间
            {{ clearConf.addTime1 }} 秒
          </li>

          <li>每消除一个宝石获得 {{ getScoreOfOne }} 个金豆</li>
          <li>所有时间用完后,结算金豆</li>
        </ul>
        <br />
        <h1>当前金豆: {{ user_score }}</h1>
        <br /><br />

        <van-button
          type="danger"
          plain
          @click="gameStart()"
          :loading="progress < 1"
          :loading-text="parseInt(progress * 100) + ' %'"
          :disabled="play_times_today >= play_times_max"
        >
          开始游戏 {{ play_times_today }}/{{ play_times_max }}
        </van-button>
        <br /><br />
        <!-- <van-button type="info" plain @click="quit()"> 退出 </van-button> -->
      </div>
    </van-popup>

    <van-popup v-model="showEndTip" :style="{ height: '100%', width: '100%' }">
      <div class="panel">
        <br /><br /><br />
        <h1 class="logo">游戏结束</h1>
        <br /><br /><br />
        <h2>结算中,请稍后...</h2>
      </div>
    </van-popup>

    <van-popup v-model="showEnd" :style="{ height: '100%', width: '100%' }">
      <div class="panel">
        <h1 class="logo">弹球</h1>
        <br /><br /><br />
        <div class="endInfo">
          <br />
        <van-tag v-if="play_times_free>play_times_today" type="success" size="large">今日免费次数： {{play_times_today}} / {{play_times_free}}</van-tag>
        <br /><br />
          <h2>获得金豆: {{ score }}</h2>
          <h2>移动步数: {{ steps }}</h2>
        </div>

        <br />
        <h1>当前金豆: {{ user_score }}</h1>
        <br /><br />
        <van-button type="danger" plain @click="gameStart()"
          :disabled ="play_times_today>=play_times_max"
          >重新开始 {{play_times_today}}/{{play_times_max}}</van-button
        >
        <br /><br />
        <van-button type="primary" plain @click="showInfo()"
          >查看规则</van-button
        >
        <br /><br />
        <!-- <van-button type="info" plain @click="quit()">退出</van-button> -->
      </div>
    </van-popup>
  </div>
</template>
<style scoped>
#game7 {
  height: auto !important;
}
.box {
  padding: 10px;
  padding-top: 1.5rem;
  height: 100vh;
  background-image: url(http://game-ns.hdmingpinmall.cn/games/xiaoxiaole/sprites/bg.jpg);
}
.info {
  padding: 15px;
  margin-bottom: 0.5rem;
}
.info span {
  font-size: 0.7rem;
}
.van-popup {
  background-color: #00000000;
  color: white;
}
.text-right {
  text-align: right;
}
.copy {
  margin-top: 0.5rem;
  text-align: center;
}
.panel {
  padding: 2rem 0.5rem;
  /* background-color:white; */
  text-align: center;
}
.panel .logo {
  font-size: 1rem;
  color: tomato;
}
.endInfo h2 {
  font-size: 0.5rem;
}
</style>
<script>
import Vue from "vue";
import { Popup } from "vant";
import { Button } from "vant";
import { Col, Row } from "vant";
import { Toast } from "vant";
Vue.use(Col);
Vue.use(Row);
Vue.use(Button);
Vue.use(Popup);
import { Tag } from 'vant';
Vue.use(Tag);
import { VUE_GAME_ASSETS_URL } from "@utils";
import { game7_config, game7_start, game7_end } from "@api/game";
import Phaser from "phaser";
export default {
  name: "Game7_xiaoxiaole",
  data() {
    return {
      user_id: 0,
      user_score: 0,
      log_id: 0,
      playScore: 100,
      playTime: 30,
      getScoreOfOne: 1,

      clearConf: {
        addTimeDefault: 1,
        count1: 5,
        addTime1: 3,
        count2: 8,
        addTime2: 8,
      },

      play_times_today: 10,
      play_times_max: 10,
      play_times_free:0,

      progress: 0,
      showStart: true,
      showEndTip: false,
      showEnd: false,
      score: 0,
      time: 0,
      steps: 0,

      scoreOneStep: 0,
    };
  },
  mounted: function () {
    this.user_id=this.getQueryVariable('uid')
    vm = this;
    let that = this;
    // getUserInfo_game(this.user_id).then(res => {
      game7_config({ user_id: that.user_id }).then((res) => {
        that.playScore = res.data.price;
        that.playTime = res.data.gameConf.playTime;
        that.getScoreOfOne = res.data.gameConf.getScoreOfOne;
        that.user_score = parseFloat(res.data.user_score);
        that.clearConf = res.data.gameConf;
        that.play_times_today = res.data.play_times_today;
        that.play_times_free = res.data.play_times_free?res.data.play_times_free:0;
      });
    // });

    //   this.showStart=true;
    onload();
  },
  methods: {
    getQueryVariable(variable)
    {
          var query = window.location.href.substring(window.location.href.indexOf('?')+1);
          var vars = query.split("&");
          for (var i=0;i<vars.length;i++) {
                  var pair = vars[i].split("=");
                  if(pair[0] == variable){return pair[1];}
          }
          return(false);
    },
    init() {
      this.score = 0;
      this.time = this.playTime;
      this.steps = 0;
    },
    showInfo() {
      this.showStart = true;
      this.showEnd = false;
    },
    gameStart() {
      if (this.play_times_free<=this.play_times_today && this.user_score<this.playScore) {
        Toast.fail('金豆不足');
        return;
      }
      let that = this;
      game7_start({ user_id: that.user_id }).then((res) => {
        console.log(res);
        // that.user_score -= that.playScore;
        that.init();
        that.showStart = false;
        that.user_score = parseFloat(res.data.game_money);
        that.log_id = res.data.log_id;
        that.showEnd = false;
        timer.paused = false;
        that.play_times_today++;
      });
      console.log("游戏开始,扣除金豆,回调开始游戏");
    },
    addScore(s) {
      this.score += s * this.getScoreOfOne;
      this.scoreOneStep += s;
    },
    useStep() {
      this.scoreOneStep = 0;
      this.steps++;
    },
    settlement() {
      // 一次移动后,所有消除数量结算
      let colorStreak = this.scoreOneStep;

      let big=[this.clearConf.count1,this.clearConf.addTime1]
      let small=[this.clearConf.count2,this.clearConf.addTime2]
      if (this.clearConf.count2>this.clearConf.count1) {
        let tmp=big
        big=small
        small=tmp
      }
      
      if (colorStreak >= big[0]) {
        if (this.time > 0) this.time += big[1];
        soundGood2.play();
      } else if (colorStreak >= small[0]) {
        if (this.time > 0) this.time += small[1];
        soundGood1.play();
      } else {
        if (this.time > 0) this.time += this.clearConf.addTimeDefault;
      }
      console.log("scoreOneStep:", this.scoreOneStep,big[0],small[0]);
    },
    timeEnd() {
      let that = this;
      that.showEndTip = true;
      setTimeout(function () {
        if (that.score > 0) {
          game7_end({
            user_id: that.user_id,
            score: that.score,
            log_id: that.log_id,
          }).then(() => {});
          that.user_score += that.score;
        }
        that.showEndTip = false;
        that.showEnd = true;
        timer.paused = true;
        console.log("提交结果");
      }, 3000);
    },
    quit() {
      this.$router.push({ path: "/user" });
    },
  },
  beforeDestroy: function () {
    if (game) {
      game.destroy();
    }
  },
};
let vm;
let game;
let timer;
let gameOptions = {
  fieldSize: 7,
  gemColors: 6,
  gemSize: 100,
  swapSpeed: 200,
  fallSpeed: 100,
  destroySpeed: 200,

  offsetX: 10,
  offsetY: 10,
};
let soundGood1;
let soundGood2;
const HORIZONTAL = 1;
const VERTICAL = 2;
let onload = function () {
  let gameConfig = {
    // width: window.innerWidth*2,
    // height: window.innerHeight*2,
    // backgroundColor: "rgba(255,0,255,0)",
    parent: "game7",
    scale: {
      mode: Phaser.Scale.ScaleModes.WIDTH_CONTROLS_HEIGHT,
    },
    transparent: true,
    width: 700,
    height: 700,
    // parent: "game",
    // mode: Phaser.Scale.FIT,
    scene: playGame,
  };
  game = new Phaser.Game(gameConfig);
  // window.focus()
  // resize();
  // window.addEventListener("resize", resize, false);
};

class playGame extends Phaser.Scene {
  constructor() {
    super("PlayGame");
  }
  preload() {
    var progress = this.add.graphics();
    this.load.on("progress", function (value) {
      vm.progress = value;
      progress.clear();
      progress.fillStyle(0xff0000, 1);
      progress.fillRect(0, 485, 700 * value, 20);
    });
    this.load.on("complete", function () {
      vm.progress = 1;
      progress.destroy();
    });

    this.load.setBaseURL(VUE_GAME_ASSETS_URL);
    this.load.spritesheet("gems", "games/xiaoxiaole/sprites/gems.png", {
      frameWidth: gameOptions.gemSize,
      frameHeight: gameOptions.gemSize,
    });
    this.load.audio("bgm1", "games/xiaoxiaole/bgm1.mp3");
    this.load.audio("bgm2", "games/xiaoxiaole/bgm2.mp3");
    this.load.audio("clear", "games/xiaoxiaole/clear.mp3");
    this.load.audio("good1", "games/xiaoxiaole/good1.mp3");
    this.load.audio("good2", "games/xiaoxiaole/good2.mp3");
  }
  create() {
    let bgm = this.sound.add("bgm1");
    bgm.addMarker({
      name: "loop",
      config: {
        loop: true,
      },
    });
    bgm.play("loop");
    soundGood1 = this.sound.add("good1");
    soundGood2 = this.sound.add("good2");
    this.canPick = true;
    this.dragging = false;
    this.drawField();
    this.selectedGem = null;
    this.input.on("pointerdown", this.gemSelect, this);
    this.input.on("pointermove", this.startSwipe, this);
    this.input.on("pointerup", this.stopSwipe, this);
    timer = this.time.addEvent({
      delay: 1000,
      callback: this.timeRun,
      callbackScope: this,
      loop: true,
    });
    timer.paused = true;
  }
  timeRun() {
    vm.time--;
    if (vm.time <= 0) {
      timer.paused = true;
      vm.timeEnd();
    }
  }
  drawField() {
    this.gameArray = [];
    this.poolArray = [];
    this.gemGroup = this.add.group();
    for (let i = 0; i < gameOptions.fieldSize; i++) {
      this.gameArray[i] = [];
      for (let j = 0; j < gameOptions.fieldSize; j++) {
        let gem = this.add.sprite(
          gameOptions.gemSize * j + gameOptions.gemSize / 2,
          gameOptions.gemSize * i + gameOptions.gemSize / 2,
          "gems"
        );
        this.gemGroup.add(gem);
        do {
          let randomColor = Phaser.Math.Between(0, gameOptions.gemColors - 1);
          gem.setFrame(randomColor);
          this.gameArray[i][j] = {
            gemColor: randomColor,
            gemSprite: gem,
            isEmpty: false,
          };
        } while (this.isMatch(i, j));
      }
    }
  }
  isMatch(row, col) {
    return this.isHorizontalMatch(row, col) || this.isVerticalMatch(row, col);
  }
  isHorizontalMatch(row, col) {
    return (
      this.gemAt(row, col).gemColor == this.gemAt(row, col - 1).gemColor &&
      this.gemAt(row, col).gemColor == this.gemAt(row, col - 2).gemColor
    );
  }
  isVerticalMatch(row, col) {
    return (
      this.gemAt(row, col).gemColor == this.gemAt(row - 1, col).gemColor &&
      this.gemAt(row, col).gemColor == this.gemAt(row - 2, col).gemColor
    );
  }
  gemAt(row, col) {
    if (
      row < 0 ||
      row >= gameOptions.fieldSize ||
      col < 0 ||
      col >= gameOptions.fieldSize
    ) {
      return -1;
    }
    return this.gameArray[row][col];
  }
  gemSelect(pointer) {
    if (this.canPick) {
      this.dragging = true;
      let row = Math.floor(pointer.y / gameOptions.gemSize);
      let col = Math.floor(pointer.x / gameOptions.gemSize);
      let pickedGem = this.gemAt(row, col);
      if (pickedGem != -1) {
        if (this.selectedGem == null) {
          pickedGem.gemSprite.setScale(1.2);
          pickedGem.gemSprite.setDepth(1);
          this.selectedGem = pickedGem;
        } else {
          if (this.areTheSame(pickedGem, this.selectedGem)) {
            this.selectedGem.gemSprite.setScale(1);
            this.selectedGem = null;
          } else {
            if (this.areNext(pickedGem, this.selectedGem)) {
              this.selectedGem.gemSprite.setScale(1);
              this.swapGems(this.selectedGem, pickedGem, true);
            } else {
              this.selectedGem.gemSprite.setScale(1);
              pickedGem.gemSprite.setScale(1.2);
              this.selectedGem = pickedGem;
            }
          }
        }
      }
    }
  }
  startSwipe(pointer) {
    if (this.dragging && this.selectedGem != null) {
      let deltaX = pointer.downX - pointer.x;
      let deltaY = pointer.downY - pointer.y;
      let deltaRow = 0;
      let deltaCol = 0;
      if (
        deltaX > gameOptions.gemSize / 2 &&
        Math.abs(deltaY) < gameOptions.gemSize / 4
      ) {
        deltaCol = -1;
      }
      if (
        deltaX < -gameOptions.gemSize / 2 &&
        Math.abs(deltaY) < gameOptions.gemSize / 4
      ) {
        deltaCol = 1;
      }
      if (
        deltaY > gameOptions.gemSize / 2 &&
        Math.abs(deltaX) < gameOptions.gemSize / 4
      ) {
        deltaRow = -1;
      }
      if (
        deltaY < -gameOptions.gemSize / 2 &&
        Math.abs(deltaX) < gameOptions.gemSize / 4
      ) {
        deltaRow = 1;
      }
      if (deltaRow + deltaCol != 0) {
        let pickedGem = this.gemAt(
          this.getGemRow(this.selectedGem) + deltaRow,
          this.getGemCol(this.selectedGem) + deltaCol
        );
        if (pickedGem != -1) {
          this.selectedGem.gemSprite.setScale(1);
          this.swapGems(this.selectedGem, pickedGem, true);
          // this.dragging = false; not necessary anymore
        }
      }
    }
  }
  stopSwipe() {
    this.dragging = false;
  }
  areTheSame(gem1, gem2) {
    return (
      this.getGemRow(gem1) == this.getGemRow(gem2) &&
      this.getGemCol(gem1) == this.getGemCol(gem2)
    );
  }
  getGemRow(gem) {
    return Math.floor(gem.gemSprite.y / gameOptions.gemSize);
  }
  getGemCol(gem) {
    return Math.floor(gem.gemSprite.x / gameOptions.gemSize);
  }
  areNext(gem1, gem2) {
    return (
      Math.abs(this.getGemRow(gem1) - this.getGemRow(gem2)) +
        Math.abs(this.getGemCol(gem1) - this.getGemCol(gem2)) ==
      1
    );
  }
  swapGems(gem1, gem2, swapBack) {
    this.swappingGems = 2;
    this.canPick = false;
    this.dragging = false;
    let fromColor = gem1.gemColor;
    let fromSprite = gem1.gemSprite;
    let toColor = gem2.gemColor;
    let toSprite = gem2.gemSprite;
    let gem1Row = this.getGemRow(gem1);
    let gem1Col = this.getGemCol(gem1);
    let gem2Row = this.getGemRow(gem2);
    let gem2Col = this.getGemCol(gem2);
    this.gameArray[gem1Row][gem1Col].gemColor = toColor;
    this.gameArray[gem1Row][gem1Col].gemSprite = toSprite;
    this.gameArray[gem2Row][gem2Col].gemColor = fromColor;
    this.gameArray[gem2Row][gem2Col].gemSprite = fromSprite;
    this.tweenGem(gem1, gem2, swapBack);
    this.tweenGem(gem2, gem1, swapBack);
  }
  tweenGem(gem1, gem2, swapBack) {
    let row = this.getGemRow(gem1);
    let col = this.getGemCol(gem1);
    this.tweens.add({
      targets: this.gameArray[row][col].gemSprite,
      x: col * gameOptions.gemSize + gameOptions.gemSize / 2,
      y: row * gameOptions.gemSize + gameOptions.gemSize / 2,
      duration: gameOptions.swapSpeed,
      callbackScope: this,
      onComplete: function () {
        this.swappingGems--;
        if (this.swappingGems == 0) {
          if (!this.matchInBoard() && swapBack) {
            this.swapGems(gem1, gem2, false);
          } else {
            if (this.matchInBoard()) {
              // 移动后开始消除
              vm.useStep();
              this.handleMatches();
            } else {
              this.canPick = true;
              this.selectedGem = null;
            }
          }
        }
      },
    });
  }
  matchInBoard() {
    for (let i = 0; i < gameOptions.fieldSize; i++) {
      for (let j = 0; j < gameOptions.fieldSize; j++) {
        if (this.isMatch(i, j)) {
          return true;
        }
      }
    }
    return false;
  }
  handleMatches() {
    this.removeMap = [];
    for (let i = 0; i < gameOptions.fieldSize; i++) {
      this.removeMap[i] = [];
      for (let j = 0; j < gameOptions.fieldSize; j++) {
        this.removeMap[i].push(0);
      }
    }
    this.markMatches(HORIZONTAL);
    this.markMatches(VERTICAL);
    this.destroyGems();
  }
  markMatches(direction) {
    for (let i = 0; i < gameOptions.fieldSize; i++) {
      let colorStreak = 1;
      let currentColor = -1;
      let startStreak = 0;
      let colorToWatch = 0;
      for (let j = 0; j < gameOptions.fieldSize; j++) {
        if (direction == HORIZONTAL) {
          colorToWatch = this.gemAt(i, j).gemColor;
        } else {
          colorToWatch = this.gemAt(j, i).gemColor;
        }
        if (colorToWatch == currentColor) {
          colorStreak++;
        }
        if (colorToWatch != currentColor || j == gameOptions.fieldSize - 1) {
          if (colorStreak >= 3) {
            vm.addScore(colorStreak);
            this.sound.add("clear").play();

            // if (colorStreak >= 5) {
            //     if (vm.time>0) vm.time+=vm.clearConf.addTime2;
            //     this.sound.add("good2").play();
            // }else if(colorStreak >= vm.clearConf.count1) {
            //     if (vm.time>0) vm.time+=vm.clearConf.addTime1;
            //     this.sound.add("good1").play();
            // }else{
            //     if (vm.time>0) vm.time+=vm.clearConf.addTimeDefault;
            // }

            if (direction == HORIZONTAL) {
              console.log(
                "HORIZONTAL :: Length = " +
                  colorStreak +
                  " :: Start = (" +
                  i +
                  "," +
                  startStreak +
                  ") :: Color = " +
                  currentColor
              );
            } else {
              console.log(
                "VERTICAL :: Length = " +
                  colorStreak +
                  " :: Start = (" +
                  startStreak +
                  "," +
                  i +
                  ") :: Color = " +
                  currentColor
              );
            }
            for (let k = 0; k < colorStreak; k++) {
              if (direction == HORIZONTAL) {
                this.removeMap[i][startStreak + k]++;
              } else {
                this.removeMap[startStreak + k][i]++;
              }
            }
          }
          startStreak = j;
          colorStreak = 1;
          currentColor = colorToWatch;
        }
      }
    }
  }
  destroyGems() {
    let destroyed = 0;
    for (let i = 0; i < gameOptions.fieldSize; i++) {
      for (let j = 0; j < gameOptions.fieldSize; j++) {
        if (this.removeMap[i][j] > 0) {
          destroyed++;
          this.tweens.add({
            targets: this.gameArray[i][j].gemSprite,
            alpha: 0.5,
            duration: gameOptions.destroySpeed,
            callbackScope: this,
            onComplete: function () {
              destroyed--;
              this.gameArray[i][j].gemSprite.visible = false;
              this.poolArray.push(this.gameArray[i][j].gemSprite);
              if (destroyed == 0) {
                this.makeGemsFall();
                this.replenishField();
              }
            },
          });
          this.gameArray[i][j].isEmpty = true;
        }
      }
    }
  }
  makeGemsFall() {
    for (let i = gameOptions.fieldSize - 2; i >= 0; i--) {
      for (let j = 0; j < gameOptions.fieldSize; j++) {
        if (!this.gameArray[i][j].isEmpty) {
          let fallTiles = this.holesBelow(i, j);
          if (fallTiles > 0) {
            this.tweens.add({
              targets: this.gameArray[i][j].gemSprite,
              y:
                this.gameArray[i][j].gemSprite.y +
                fallTiles * gameOptions.gemSize,
              duration: gameOptions.fallSpeed * fallTiles,
            });
            this.gameArray[i + fallTiles][j] = {
              gemSprite: this.gameArray[i][j].gemSprite,
              gemColor: this.gameArray[i][j].gemColor,
              isEmpty: false,
            };
            this.gameArray[i][j].isEmpty = true;
          }
        }
      }
    }
  }
  holesBelow(row, col) {
    let result = 0;
    for (let i = row + 1; i < gameOptions.fieldSize; i++) {
      if (this.gameArray[i][col].isEmpty) {
        result++;
      }
    }
    return result;
  }
  replenishField() {
    let replenished = 0;
    for (let j = 0; j < gameOptions.fieldSize; j++) {
      let emptySpots = this.holesInCol(j);
      if (emptySpots > 0) {
        for (let i = 0; i < emptySpots; i++) {
          replenished++;
          let randomColor = Phaser.Math.Between(0, gameOptions.gemColors - 1);
          this.gameArray[i][j].gemColor = randomColor;
          this.gameArray[i][j].gemSprite = this.poolArray.pop();
          this.gameArray[i][j].gemSprite.setFrame(randomColor);
          this.gameArray[i][j].gemSprite.visible = true;
          this.gameArray[i][j].gemSprite.x =
            gameOptions.gemSize * j + gameOptions.gemSize / 2;
          this.gameArray[i][j].gemSprite.y =
            gameOptions.gemSize / 2 - (emptySpots - i) * gameOptions.gemSize;
          this.gameArray[i][j].gemSprite.alpha = 1;
          this.gameArray[i][j].isEmpty = false;
          this.tweens.add({
            targets: this.gameArray[i][j].gemSprite,
            y: gameOptions.gemSize * i + gameOptions.gemSize / 2,
            duration: gameOptions.fallSpeed * emptySpots,
            callbackScope: this,
            onComplete: function () {
              replenished--;
              if (replenished == 0) {
                if (this.matchInBoard()) {
                  this.time.addEvent({
                    delay: 250,
                    callback: this.handleMatches(),
                  });
                } else {
                  // 一波消除结束
                  vm.settlement();
                  this.canPick = true;
                  this.selectedGem = null;
                }
              }
            },
          });
        }
      }
    }
  }
  holesInCol(col) {
    var result = 0;
    for (let i = 0; i < gameOptions.fieldSize; i++) {
      if (this.gameArray[i][col].isEmpty) {
        result++;
      }
    }
    return result;
  }
}
// function resize() {
//   var canvas = document.querySelector("canvas");
//   var windowWidth = window.innerWidth;
//   var windowHeight = window.innerHeight;
//   var windowRatio = windowWidth / windowHeight;
//   var gameRatio = game.config.width / game.config.height;
//   if (windowRatio < gameRatio) {
//     canvas.style.width = windowWidth + "px";
//     canvas.style.height = windowWidth / gameRatio + "px";
//   } else {
//     canvas.style.width = windowHeight * gameRatio + "px";
//     canvas.style.height = windowHeight + "px";
//   }
// }
</script>

